// frontend/src/pages/home/HomePage.js
import React, { useRef, useEffect, useState } from 'react';
import '../../styles/Home/HomePage.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper';
import { icons } from '../../assets';
import { HomePageNavbar } from './HomePageNavbar';
import heroVideo from '../../assets/videos/heroHeader.mp4';

export const HomePage = ({ darkMode }) => {
  const scrollRef = useRef(null);
  const [showPromos, setShowPromos] = useState(false);
  const [showDiscord, setShowDiscord] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = document.querySelector('.hero').offsetHeight;
      if (window.scrollY > heroHeight * 0.9) {
        setShowPromos(true);
        setShowDiscord(true);
      } else {
        setShowPromos(false);
        setShowDiscord(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const sc = scrollRef.current;
    if (!sc) return;
    const autoScroll = () => {
      const { scrollWidth, scrollLeft, clientWidth } = sc;
      sc.scrollBy({ left: 200, behavior: 'smooth' });
      if (scrollLeft + clientWidth >= scrollWidth) {
        sc.scrollTo({ left: 0, behavior: 'smooth' });
      }
    };
    const id = setInterval(autoScroll, 3000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={`home-page ${darkMode ? 'dark' : 'light'}`}>
      <HomePageNavbar darkMode={darkMode} title="Home" />

      <header className="hero">
        <div className="hero-container">
        <a
          href="https://discord.gg/2JHafcA4WS"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-container-link"
        >
          <video
            className="hero-bg"
            src={heroVideo}
            autoPlay
            muted
            loop
            playsInline
          />
          <a
            href="https://discord.gg/2JHafcA4WS"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-cta"
          >
            <span className="hero-cta-text">
              Click <span className="highlight">HERE</span> to{' '}
              <span className="highlight">JOIN OUR DISCORD!</span>
            </span>
            <img
              src={icons.discordJoin}
              alt="Discord"
              className="discord-image"
            />
          </a>
          </a>
        </div>
      </header>

      <aside className={`promo-sidebar ${showPromos ? 'show-left' : ''}`}>
        <a href="https://betr.com" target="_blank" rel="noopener noreferrer">
          <img
            src={icons.betrPromo}
            alt="Betr Promotion"
            className="promo-image"
          />
        </a>
        <a href="https://chalkboard.com" target="_blank" rel="noopener noreferrer">
          <img
            src={icons.chalkboardPromo}
            alt="Chalkboard Promotion"
            className="promo-image"
          />
        </a>
      </aside>

      <aside className={`discord-sidebar ${showDiscord ? 'show-right' : ''}`}>
        <a
          href="https://discord.gg/2JHafcA4WS"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={darkMode ? icons.discordSideBlack : icons.discordSideWhite}
            alt="Discord Side Promo"
            className="discord-side-image"
          />
        </a>
      </aside>

      <section className="features">
        <h2>What We Offer</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <h3>Player Prop Insights</h3>
            <p>Analyze players like a professional. Find trends and patterns.</p>
          </div>
          <div className="feature-card">
            <h3>Community</h3>
            <p>Weekly GIVEAWAYS & monthly GOBLIN challenges</p>
          </div>
          <div className="feature-card">
            <h3>Odds</h3>
            <p>Latest Odds from multiple sportsbooks. Including +EV bets.</p>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="testimonials-container">
          <div className="testimonials-heading">
            <h2>What Users Say</h2>
          </div>
          <div className="testimonials-carousel">
            <Swiper
              breakpoints={{
                0: { slidesPerView: 1 },
                640: { slidesPerView: 1.5 },
                1024: { slidesPerView: 2.5 }
              }}
              spaceBetween={0}
              loop
              autoplay={{ delay: 0, disableOnInteraction: false }}
              speed={10000}
              modules={[Autoplay]}
              style={{ overflow: 'visible', width: '100%' }}
            >
              <SwiperSlide>
                <div className="testimonial-card">
                  <p>"El Parlay has revolutionized my sports betting strategy!"</p>
                  <span>- John D.</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-card">
                  <p>"Research with El Parlay = NEW SET OF NAILS💅"</p>
                  <span>- Sarah P.</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-card">
                  <p>"4-25x winnings in just 4 days thanks to the insights!"</p>
                  <span>- Mike T.</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-card">
                  <p>"I love the community and the challenges!"</p>
                  <span>- Anna R.</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-card">
                  <p>"Always on top of the latest odds!"</p>
                  <span>- Kevin L.</span>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testimonial-card">
                  <p>"The tools and insights are unmatched."</p>
                  <span>- Maria S.</span>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section className="recent-wins" ref={scrollRef}>
        <h1>Recent El Parlay Community Wins</h1>
        <div className="scroll-snap-container">
          <div className="scroll-snap-item">
            <img src={icons.win1} alt="Win 1" />
          </div>
          <div className="scroll-snap-item">
            <img src={icons.win2} alt="Win 2" />
          </div>
          <div className="scroll-snap-item">
            <img src={icons.win3} alt="Win 3" />
          </div>
          <div className="scroll-snap-item">
            <img src={icons.win4} alt="Win 4" />
          </div>
        </div>
      </section>
    </div>
  );
};
